import { fetchApi } from '@/services/api-client';

export const ANALYTICS_PATH = '/analytics';

export type AnalyticsRange = { from?: string; to?: string; includeInternal?: boolean };

export type DeviceBreakdown = { deviceType: string | null; visitors: number };
export type ChannelBreakdown = { channel: string | null; visitors: number };
export type LocationRow = { country: string | null; region: string | null; city: string | null; visitors: number };
export type CountryRow = { country: string | null; visitors: number };
export type TimeseriesPoint = { date: string; uniqueVisitors: number; pageviews: number };

export type AnalyticsSummary = {
  uniqueVisitors: number;
  pageviews: number;
  sessions: number;
  newVisitors: number;
  returningVisitors: number;
  devices: DeviceBreakdown[];
  sources: ChannelBreakdown[];
  locations: LocationRow[];
  countries: CountryRow[];
  timeseries: TimeseriesPoint[];
};

export type FunnelStep = { step: string; sessions: number; dropOffPct: number };
export type FormFunnel = { formId: string; starts: number; submits: number; abandonmentPct: number };
export type DownloadStat = { fileName: string; uniqueDownloaders: number; total: number };

function qs(range: AnalyticsRange): string {
  const params = new URLSearchParams();
  if (range.from) params.append('from', range.from);
  if (range.to) params.append('to', range.to);
  if (range.includeInternal) params.append('includeInternal', '1');
  const s = params.toString();
  return s ? `?${s}` : '';
}

export const analyticsApi = {
  getSummary: (range: AnalyticsRange = {}) => fetchApi<AnalyticsSummary>(`${ANALYTICS_PATH}/summary${qs(range)}`),
  getFunnel: (range: AnalyticsRange = {}) => fetchApi<FunnelStep[]>(`${ANALYTICS_PATH}/funnel${qs(range)}`),
  getForms: (range: AnalyticsRange = {}) => fetchApi<FormFunnel[]>(`${ANALYTICS_PATH}/forms${qs(range)}`),
  getDownloads: (range: AnalyticsRange = {}) => fetchApi<DownloadStat[]>(`${ANALYTICS_PATH}/downloads${qs(range)}`),
};
